import React from 'react';
import { Modal } from 'antd';
import './delete-modal.less';

type DeleteModal = {
  text: string;
  modalVisible: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
};

const DeleteModal = ({
  text,
  modalVisible,
  onCancel,
  onConfirm,
}: DeleteModal): JSX.Element => (
  <Modal
    title={null}
    closable={false}
    centered
    visible={modalVisible}
    wrapClassName="wrapper"
    okText="Delete"
    onOk={onConfirm}
    onCancel={onCancel}
  >
    <button onClick={onCancel} type="button" className="button__close">
      Close
    </button>

    <div className="ant-modal-body__content">
      <div className="ant-modal-body__content__title">{`Delete ${text}?`}</div>
      <span className="ant-modal-body__content__text">{`Are you sure you want to delete ${text}?`}</span>
    </div>
  </Modal>
);

DeleteModal.displayName = 'DeleteModal';

export default DeleteModal;
